import { useAuthStore } from '@/stores/authStore'

export function useAuthentication() {
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async beforeEnter(before: any, after: any, next: any) {
      // get store
      if (useAuthStore().isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  }
}
